import { $isMounted, onMountMain, onUnmountMain } from 'src/processes/core/model'
import { useEvent, useStore } from 'effector-react'

export const useOnMountMain = () => useEvent(onMountMain)
export const useOnUnmountMain = () => useEvent(onUnmountMain)

export const useMounted = () => useStore($isMounted)
